import { isNil } from 'ramda'

import type {
  Category,
  CategoryListResponseDataItemCustom,
} from '@twisto/api-cms'

import {
  ArticleList,
  CategoryBreadcrumbs,
  CategoryContentNavigation,
  CategoryLayout,
  SubcategoryList,
} from '../../components'

export const CategoryOverview = ({
  rootCategoryId,
  articles,
  categories,
  name,
  parent,
  path,
}: CategoryListResponseDataItemCustom['attributes'] & {
  categories?: Category[]
}) => (
  <CategoryLayout
    breadcrumbs={
      <CategoryBreadcrumbs
        category={
          {
            name,
            parent,
            path,
          } as Category
        }
      />
    }
    contentNavigation={
      <CategoryContentNavigation
        parent={parent as CategoryListResponseDataItemCustom['attributes']}
      />
    }
    rootCategoryId={rootCategoryId}
  >
    {!isNil(articles) && articles.length !== 0 ? (
      <ArticleList
        articles={articles}
        categories={categories}
        categoryName={name}
      />
    ) : (
      <SubcategoryList categories={categories} categoryName={name} />
    )}
  </CategoryLayout>
)
